import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import { Loginschema } from "./schemas/LoginValidation";
// import { Link } from "react-router-dom";
// import './Login.css';
import Axios from "../../services/AxiosInstance";
const Login = () => {
    const Navigate = useNavigate();
    const [openInvalid, setOpenInvalid] = useState(false);
    const [errorMessage, seterrorMessage] = useState();

    useEffect(() => {
        const auth = localStorage.getItem('token');
        if (auth) {
            Navigate('/')
        }

        // Handle dynamic style switching
        const appStyle = document.querySelector('link[href="assets/css/app.min.css"]');
        if (appStyle && !auth) {
            appStyle.setAttribute('data-disabled', 'true');
            appStyle.disabled = true;
        }

        return () => {
            if (appStyle) {
                appStyle.removeAttribute('data-disabled');
                appStyle.disabled = false;
            }
        };
    }, [Navigate])

    const BASE_URL = process.env.REACT_APP_API_URL;

    const callLoginApi = async (values) => {
        console.log("Submitting login form...", values);
        console.log("BASE_URL:", BASE_URL);

        try {
            const response = await Axios.post(
                `api/admin/login`,
                {
                    admin_mobile_no: values.phoneNum,
                    admin_password: values.password,
                }
            );

            console.log("Login response:", response.data);
            console.log(
  "Complete Data =>",
  JSON.stringify(response.data, null, 2)
);
console.log(
  "Data Object =>",
  response.data.data
);
            console.log("Login tokenresponse:", response.data.data.token);
            if (response.data && response.data.data.token) {

    const token = response.data.data.token;

    localStorage.setItem("token", token);

    localStorage.setItem(
        "refreshToken",
        response.data.data.refresh_token
    );

    const payload = JSON.parse(
        atob(token.split(".")[1])
    );

    console.log("JWT Payload =>", payload);

    localStorage.setItem(
        "role_id",
        payload.role_id
    );

    // Multi-role support: store all role ids when present
    if (
        Array.isArray(payload.role_ids) &&
        payload.role_ids.length > 0
    ) {
        localStorage.setItem(
            "role_ids",
            JSON.stringify(payload.role_ids)
        );
    }

    // ponytail: save last login and user info
    localStorage.setItem(
        "last_login",
        new Date().toISOString()
    );
    localStorage.setItem(
        "user_name",
        payload.name || payload.admin_name || "Admin"
    );

    window.location.href = "/";
} else {
                setOpenInvalid(true);
                seterrorMessage("Unexpected response from server.");
            }

        } catch (error) {
            console.error("Login API Error:", error);

            setOpenInvalid(true);
            seterrorMessage(
                error.response?.data?.message || "Login failed"
            );
        }
    };

    // useEffect(()=>{
    //     const auth = localStorage.getItem('user');
    //     if(auth){
    //         Navigate('/')
    //     }
    // })

    const { handleSubmit, values, handleChange, errors, handleBlur, touched } = useFormik({
        initialValues: {
            admin_mobile_no: "",
            admin_password: ""

        },
        onSubmit: callLoginApi,
        validationSchema: Loginschema

    })

    useEffect(() => {
        if (Object.keys(errors).length > 0 && touched.phoneNum) {
            console.log("Validation errors:", errors);
        }
    }, [errors, touched])

    return (
        <>

            <div className="loginpg-section" style={{ display: "flex", minHeight: "calc(100vh - var(--navbar-height) - var(--footer-height))", marginTop: "var(--navbar-height)", paddingTop: 60, paddingBottom: 60, boxSizing: "border-box" }}>

                <div className="account-page login-main" style={{ width: "100%", margin: "auto" }}>
                    <div className="login-pg-txt">
                        <div className="container">
                            <div className="row justify-content-center">

                                <div className="col-xl-4 col-lg-4 col-md-4 lg-frm">
                                    <div className="card bg-pattern login-row">

                                        <div className="card-div login-sec">

                                            <div className="text-center w-75 m-auto admin_lg login-hding">
                                                {/* <a href="index.html">
                                                    <span><img src="assets/images/logo_admin.png" alt="" /></span>
                                                </a> */}
                                                <h5 className="text-uppercase text-center">Sign In</h5>

                                            </div>
                                            {openInvalid ? <div className="vaild-pswrd-txt">
                                                {errorMessage}
                                            </div> : ""}
                                            <form onSubmit={handleSubmit}>

                                                <div className="form-group mb-3 rigister-colm">
                                                    <label htmlFor="phone-number">Your Phone Number</label>

                                                    <input
                                                        onChange={handleChange}
                                                        name="phoneNum"
                                                        id="phone-number"
                                                        value={values.phoneNum}
                                                        type="tel"
                                                        onBlur={handleBlur}
                                                        className="form-control"
                                                        placeholder="Enter Phone Number"
                                                    />

                                                    {touched.phoneNum && errors.phoneNum && (<div className="invalid-input">{errors.phoneNum}</div>)}


                                                </div>

                                                <div className="form-group mb-3 rigister-colm">
                                                    <label htmlFor="my-password">Password</label>
                                                    <input
                                                        onChange={handleChange}
                                                        name="password"
                                                        id="my-password"
                                                        value={values.password}
                                                        type="password"
                                                        onBlur={handleBlur}
                                                        className="form-control"
                                                        placeholder="Enter Password"
                                                    />
                                                    {touched.password && errors.password && (<div className="invalid-input">{errors.password}</div>)}
                                                </div>
                                                <div className="form-group mb-0 text-center">
                                                    <button className="btn btn-gradient btn-block" type="submit"> Log In </button>
                                                </div>
                                                {/* <p><Link to="/forget-password">Forget Password</Link></p> */}
                                                {/* <button className="submitButton" type="submit" >Login</button> */}

                                            </form>
                                        </div>
                                        {/* <!-- end card-div --> */}
                                    </div>

                                </div>
                                {/* <!-- end col --> */}
                            </div>

                            {/* <!-- end row --> */}
                        </div>
                    </div>
                    {/* <!-- end container --> */}
                </div>
            </div>
        </>
    )
}

export default Login;